import PropTypes from "prop-types";
import { useJobOpeningLogs } from "../../../app/hooks/useJobOpenings";
import { Spin, Empty } from "antd";
import dayjs from "dayjs";

const JobTimeline = ({ jobId }) => {
  const { logs, isLoading } = useJobOpeningLogs(jobId);

  if (isLoading) {
    return (
      <div className="flex justify-center py-10">
        <Spin tip="Loading logs..." />
      </div>
    );
  }

  if (!logs || logs.length === 0) {
    return <Empty description="No activity logs found" className="mt-10" />;
  }

  const groupedLogs = logs.reduce((acc, log) => {
    const date = dayjs(log.performedAt).format("MMMM D");
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(log);
    return acc;
  }, {});

  return (
    <div className="mt-4 space-y-8">
      {Object.keys(groupedLogs).map((date) => (
        <div key={date}>
          <p className="text-gray-500 text-sm">{date}</p>
          {groupedLogs[date].map((event, index) => (
            <div key={index} className="flex items-center justify-between py-2 pl-3">
              <span className="flex items-center">
                <div className="w-8 h-8 rounded-full bg-gray-300 mr-2"> {event.avatar}</div>
                <span className="font-semibold mr-1">{event.performedUserFullName}</span> {event.action === "Created" ? "posted" : event.action?.toLowerCase()}{" "}
                this post
              </span>
              <span className="text-sm text-gray-500">{dayjs(event.performedAt).format("h:mm A")}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

JobTimeline.propTypes = {
  jobId: PropTypes.string,
};

export default JobTimeline;
